import React from 'react';
import { RetoolEmbedContainer } from './styled';
import RetoolEmbed from '../RetoolEmbed';

interface DashboardGridProps {
  selectedPage: string;
}

const DashboardGrid = ({ selectedPage }: DashboardGridProps) => {
  return (
    <>
      <RetoolEmbedContainer>
        <RetoolEmbed retoolPage={selectedPage} />
      </RetoolEmbedContainer>
    </>
  );
};

export default DashboardGrid;
